var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46 31.1306C46 25.4224 42.7253 20.3279 37.8207 17.8499C37.6684 28.7947 28.7949 37.6681 17.8501 37.8204C20.3282 42.725 25.4226 45.9997 31.1309 45.9997C33.8072 45.9997 36.4099 45.287 38.6967 43.9326L45.9351 45.9348L43.9329 38.6964C45.2872 36.4096 46 33.807 46 31.1306Z",
    fill: "#5BA1FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1289 17.5645C35.1289 7.87923 27.2497 0 17.5645 0C7.87923 0 0 7.87923 0 17.5645C0 20.7209 0.840179 23.7942 2.43561 26.4923L0.0645752 35.064L8.63658 32.6933C11.3347 34.2887 14.408 35.1289 17.5645 35.1289C27.2497 35.1289 35.1289 27.2497 35.1289 17.5645ZM14.8691 13.4766H12.1738C12.1738 10.504 14.5919 8.08594 17.5645 8.08594C20.537 8.08594 22.9551 10.504 22.9551 13.4766C22.9551 14.9853 22.3163 16.4354 21.2021 17.4546L18.9121 19.5505V21.6523H16.2168V18.3636L19.3824 15.4661C19.9481 14.9485 20.2598 14.242 20.2598 13.4766C20.2598 11.9903 19.0507 10.7812 17.5645 10.7812C16.0782 10.7812 14.8691 11.9903 14.8691 13.4766ZM16.2168 24.3477H18.9121V27.043H16.2168V24.3477Z",
    fill: "#5BA1FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHelp);
export default __webpack_public_path__ + "static/media/icon-help.bf69d39aca077354b151ad3406730c9d.svg";
export { ForwardRef as ReactComponent };